import {useId} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../../app/rp_reducer";
import {articleListBoxTitle, ArticleListBoxWide} from "../../../../article/components/article_list/ArticleListBoxWide";
import {PricesHubViewSectionTracker} from "./PricesHubViewSectionTracker";

export const PricesHubArticles = () => {
    const headingId = useId();
    const articles = useSelector((store: IRPStore) => store.report.price.articles);

    if (articles.length === 0) {
        return null;
    }

    return (
        <section className={sectionStyle} aria-labelledby={headingId}>
            <PricesHubViewSectionTracker sectionName="articles" />

            <Container maxWidthVariant="lg">
                <div className={innerStyle}>
                    <Text id={headingId} as="h2" variant="headline_3" className={headingStyle}>
                        Raporty i analizy cenowe
                    </Text>

                    <ul className={listStyle}>
                        {articles.map((article) => (
                            <li key={article.id}>
                                <ArticleListBoxWide
                                    article={article}
                                    articleTitle={
                                        <Text as="h3" variant="headline_4" className={articleListBoxTitle}>
                                            {article.header}
                                        </Text>
                                    }
                                />
                            </li>
                        ))}
                    </ul>

                    <div className={actionStyle}>
                        <Button variant="outlined_secondary" href={rpAppLink.article.category({categorySlug: "raporty"})} target="_blank" rel="noopener">
                            Zobacz więcej
                        </Button>
                    </div>
                </div>
            </Container>
        </section>
    );
};

const sectionStyle = css({
    py: 6,

    md: {
        py: 8
    }
});

const innerStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,

    md: {
        gap: 3
    }
});

const headingStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const listStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    margin: 0,
    padding: 0,
    listStyle: "none"
});

const actionStyle = css({
    display: "flex",
    justifyContent: "center"
});
import {useId} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../../app/rp_reducer";
import {articleListBoxTitle, ArticleListBoxWide} from "../../../../article/components/article_list/ArticleListBoxWide";
import {PricesHubViewSectionTracker} from "./PricesHubViewSectionTracker";

export const PricesHubArticles = () => {
    const headingId = useId();
    const articles = useSelector((store: IRPStore) => store.report.price.articles);

    if (articles.length === 0) {
        return null;
    }

    return (
        <section className={sectionStyle} aria-labelledby={headingId}>
            <PricesHubViewSectionTracker sectionName="articles" />

            <Container maxWidthVariant="lg">
                <div className={innerStyle}>
                    <Text id={headingId} as="h2" variant="headline_3" className={headingStyle}>
                        Raporty i analizy cenowe
                    </Text>

                    <ul className={listStyle}>
                        {articles.map((article) => (
                            <li key={article.id}>
                                <ArticleListBoxWide
                                    article={article}
                                    articleTitle={
                                        <Text as="h3" variant="headline_4" className={articleListBoxTitle}>
                                            {article.header}
                                        </Text>
                                    }
                                />
                            </li>
                        ))}
                    </ul>

                    <div className={actionStyle}>
                        <Button variant="outlined_secondary" href={rpAppLink.article.category({categorySlug: "raporty"})} target="_blank" rel="noopener">
                            Zobacz więcej
                        </Button>
                    </div>
                </div>
            </Container>
        </section>
    );
};

const sectionStyle = css({
    py: 6,

    md: {
        py: 8
    }
});

const innerStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,

    md: {
        gap: 3
    }
});

const headingStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const listStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    margin: 0,
    padding: 0,
    listStyle: "none"
});

const actionStyle = css({
    display: "flex",
    justifyContent: "center"
});
